import React, {useState, useEffect} from 'react';
import { useHistory } from 'react-router-dom';
import Axios from 'axios';
import ReactCodeInput from 'react-verification-code-input';

export default function Token() {
  const [tempo, setTempo] = useState(null);
  const [code, setCode] = useState('');
  const timer = () => setTempo(tempo - 1);
  const history = useHistory();
  const createInterval = () => {
    setTempo(50);
  }

  const resendNotification = async () => {
    if(tempo) {
      return true
    }
    try {
      const { data } = await Axios.get(`customers/verify/send-sms`);
    } catch(err) {
      console.log(err.response);
    } finally {
      createInterval();
    }
  }

  const send = async () => {
    if (code.length != 4) {
      alert('Preencha o código!')
      return;
    }

    try {

      let user = JSON.parse(localStorage.getItem('userDados'))

      let retorno = await Axios.get(`customers/verify/${code}/${user.email}`);
      if(localStorage.getItem('userDados')) {
        if(user) {
          localStorage.setItem('user', localStorage.getItem('userDados'));
          Axios.defaults.headers.common['Authorization'] = user.api_token;
          console.log(localStorage.getItem('user'));
          if(localStorage.getItem('direcionar_carrinho')) {
            window.location.href = '/loja/add?&product_id='+localStorage.getItem('direcionar_carrinho');
          } else {
            window.location.href = "/";
          }
        }
      }

    } catch(err) {
      console.log(err.response);
      alert(err.response.data);
      createInterval();

    }

  }

  useEffect(() => {
    createInterval()
  }, []);

  useEffect(
    () => {
      if (tempo <= 0) {
        return;
      }
      const id = setInterval(timer, 1000);
      return () => clearInterval(id);
    },
    [tempo]
  );
  return (
    <div className="content token">
      <div className="tokenText">
        Enviaremos uma mensagem para o seu celular. 
        <b> Digite o código</b> que aparecerá no seu sms
      </div>
      <div className="tokenTitle">
        Token
      </div>
      <div className="tokenArea">
        <ReactCodeInput
          fields={4}
          fieldHeight={50}
          fieldWidth={50}
          className="tokenItem"
          onComplete={val => {
            setCode(val)
          }}
        />
      </div>
      
        <div className="resendArea">
          <button className="resend" onClick={() => resendNotification()}>
            Reenviar
          </button>
          {tempo != null && (
          <div className="time">
            {tempo > 10 ? '0:'+tempo : '0:0'+tempo}
          </div>
          )}
        </div>
     
      <div className="proximoArea">
        <button type="button" onClick={send}>
          Próximo
        </button>
      </div>
    </div>
  )
}